export const GET_RULE_REQUEST = '[RULES] GET_RULE_REQUEST'
export const GET_RULE_SUCCESS = '[RULES] GET_RULE_SUCCESS'
export const GET_RULE_FAILED = '[RULES] GET_RULE_FAILED'

export const GET_RULE_LIST_REQUEST = '[RULES] GET_RULE_LIST_REQUEST'
export const GET_RULE_LIST_SUCCESS = '[RULES] GET_RULE_LIST_SUCCESS'
export const GET_RULE_LIST_FAILED = '[RULES] GET_RULE_LIST_FAILED'

export const CREATE_RULE_REQUEST = '[RULES] CREATE_RULE_REQUEST'
export const CREATE_RULE_SUCCESS = '[RULES] CREATE_RULE_SUCCESS'
export const CREATE_RULE_FAILED = '[RULES] CREATE_RULE_FAILED'

export const EDIT_RULE_REQUEST = '[RULES] EDIT_RULE_REQUEST'
export const EDIT_RULE_SUCCESS = '[RULES] EDIT_RULE_SUCCESS'
export const EDIT_RULE_FAILED = '[RULES] EDIT_RULE_FAILED'

export const DELETE_RULE_REQUEST = '[RULES] DELETE_RULE_REQUEST'
export const DELETE_RULE_SUCCESS = '[RULES] DELETE_RULE_SUCCESS'
export const DELETE_RULE_FAILED = '[RULES] DELETE_RULE_FAILED'

export const RULE_SEARCH_REQUEST = '[RULES] RULE_SEARCH_REQUEST'
export const RULE_SEARCH_SUCCESS = '[RULES] RULE_SEARCH_SUCCESS'
export const RULE_SEARCH_FAILED = '[RULES] RULE_SEARCH_FAILED'

